import { SMap, TypedOmit, TypedValue } from '@client/new/helpers/types';
import {
  ExerciseType,
  HIITExerciseDTO,
  TabataDTO,
  TabataExerciseDTO,
} from '../model/workout.domain';
import { useHIITVM, useTabataVM } from './workout.viewModel';
import { DelegatedActionMap } from '../../workout/models/workoutEdit.model';
import { useSubExerciseVM } from './subexercise.viewmodel';
import { omitObject } from '@client/new/helpers/general';

export type TabataExerciseVM = ReturnType<typeof useSubExerciseVM>;
export type TabataVM = ReturnType<typeof useTabataVM>;

export type HIITVM = ReturnType<typeof useHIITVM>;
export type HIITExerciseVM = ReturnType<typeof useSubExerciseVM>;

export type Tabata = TypedValue<
  Extract<ExerciseType, 'Tabata'>,
  TypedOmit<TabataDTO, 'exercises' | 'type'> & {
    exercises: Array<TabataExercise>;
  }
>;
export type HIIT = TypedValue<
  Extract<ExerciseType, 'HIIT'>,
  TypedOmit<TabataDTO, 'exercises' | 'type'> & {
    exercises: Array<HIITExercise>;
  }
>;
export type TabataExercise = TypedValue<
  Extract<ExerciseType, 'TabataExercise'>,
  TypedOmit<TabataExerciseDTO, 'type'>
>;
export type HIITExercise = TypedValue<
  Extract<ExerciseType, 'HIITExercise'>,
  HIITExerciseDTO
>;

export type ParentExercise = Tabata | HIIT;
export type SubExercise = TabataExercise | HIITExercise;
export type Exercise = ParentExercise | SubExercise;
export type ExerciseSettings = DelegatedActionMap['addAutoplayed'];
export type Draggable = { id: string; items: Array<{ id: string }> };

export type Workout = {
  exerciseMap: SMap<Exercise>;
  exerciseIds: Array<Draggable>;
  exerciseSettingsMap: SMap<ExerciseSettings>;
};

export const defaultTabataSettings: ExerciseSettings = {
  id: 'default',
  type: 'Tabata',
  rest: 20,
  time: 40,
  sets: 8,
  rounds: 1,
};

export const defaultHIITSettings: ExerciseSettings = {
  ...omitObject(defaultTabataSettings, ['sets']),
  type: 'HIIT',
};
